import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Button from '../../../../../../components/button';
import {connect, useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions';
import {setDetailsForContactCard} from '../../../../../../../actions/contactActions';
import './index.css'


function ContactNotFound(props) {

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);

	const {t} = useTranslation();

	const closePopup = () => {
		props.setDetailsForContactCard({});
		props.getSharingDetailsPopup([]);
	};

	return (
		<div className="p-4">
			<h2 className="pr-5">
				<img
					className="mr-4 logo-container"
                  src={`${window.location.origin}/img/shared-contacts-for-gmail-logo.png`}
                  alt={t('textGscTitle')}/>
			</h2>
			<div className="popup-container">
				<div>

					{
						selectedContactsGroup
						?
							<>
								<h2 className="heading-container">{t('textNeedAccess')}</h2>
								<p>{t('textNeedAccessMain1')} <Trans i18nKey="textNeedAccessMain2" values={{owner_name: selectedContactsGroup.ownerName}}/></p>
							</>
						:
							<>
								<h2 className="heading-container">Contact not found!</h2>
								<p>The contact you are looking for does not exist.</p>
							</>
					}

					{/* Please ask the contact list <br />owner to share it with you */}
				</div>
				<img className="mr-4 lock-logo" src={`${window.location.origin}/img/lock1.png`} alt={t('textGscTitle')}/>
			</div>
			<div className="text-right">
				<Button className="btn-primary font-weight-bold" onClick={closePopup}>{t('textNeedAccessButton')}</Button>
			</div>
		</div>
	)
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array))
		},
		setDetailsForContactCard: (object) => dispatch(setDetailsForContactCard(object))
	}
};

export default withRouter(connect(null, mapDispatchToProps)(ContactNotFound));


